// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrowserResultModal_wrapper__3fkyr"};